module.exports = __webpack_public_path__ + "static/media/store-churn-img.38bdb9d0.svg";